'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import SoftpullMfeButton from '~/components/flp-rsc/common/SoftpullMfeButton';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useConfiguration } from '~/context/common/StaticContext';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';

export default function SocialValueCta() {
  const { shouldUseTitleCasing } = useConfiguration();
  const { setSoftPullModalOpen } = useModalContext();
  const { trackEvent } = useContext(AnalyticsContext);

  const ctaClick = () => {
    datadogRum.addAction(DATADOG_EVENTS.MARKETING.CLICKS_WHYCARVANA_CTA);
    trackEvent(ANALYTICS_EVENTS.MARKETING.CLICKS_WHYCARVANA_CTA);
    setSoftPullModalOpen(true);
  };

  return (
    <SoftpullMfeButton
      data-analytics-id="Financing Get Pre-Qualified Button"
      className="w-full sm:w-auto"
      size="lg"
      onClick={ctaClick}
      data-testid="get-pre-qualified"
    >
      {shouldUseTitleCasing
        ? 'Get Pre-Qualified Today'
        : 'Get pre-qualified today'}
    </SoftpullMfeButton>
  );
}
